/**
 * Check if the format of a string corresponds to a valid email address
 * @param  {String}  address The String to check
 * @return {Boolean}         True if the String passed corresponds to a valid email address, false otherwise.
 */
function isValidEmail(address) {
	var pattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
	let trimmedAddress = address.trim();

	if (trimmedAddress.match(pattern)) {
		return true;
	}
	else {
		return false;
	}
}

/**
 * Get all the input fields from a form as an object
 * @param {HTML form} form 
 */
function getFormData(form) {
	let disabled = form.find(':disabled').removeAttr('disabled');
	let unindexed_array = $(form).serializeArray();
	disabled.prop('disabled', '');
	let indexed_array = {};

	$.map(unindexed_array, function (n, i) {
		indexed_array[n['name']] = n['value'];
	});

	return indexed_array;
}

function formatDataForAPI(value, format) {
	let formattedValue = value;

	if (value !== null) {

		switch (format) {
			// case "datetime":
			// 	if (value === "0000-00-00 00:00:00") {
			// 		formattedValue = "";
			// 	}
			// 	else {
			// 		let date = moment(value);
			// 		formattedValue = date.format("dddd DD/MM/YYYY @ hh:mm a");
			// 	}
			// 	break;

			case "date":
				if (value) {
					let datetime = moment(value, "DD/MM/YYYY");
					formattedValue = datetime.format("YYYY-MM-DD");
				}
				break;
		}
	}

	return formattedValue;
}


/**
 * Display the confirmation dialog with the content and callbacks passed in the options
 * @param {object} options Object containing the content to populate the dialog and the events callbacks
 */
function showConfirmationDialog(options) {
	let dialog = $("#atl-confirm-dialog");
	$('h3', dialog).text(options.title);
	$('.modal-body', dialog).html(`<div class="normal-body">${options.body}</div>`);

	$('.btn-action', dialog).off();
	$('.btn-action', dialog).attr("href", null);
	$('.btn-action', dialog).text(options.confirmButton.title);
	$('.btn-action', dialog).on('click', function () {

		// hide button and display spinner
		$('.btn-action', dialog).hide();
		$('.normal-body').hide();
		$('.modal-body', dialog).append(
			`<div class='loader-container-center'>
				<div class='spinner-border'></div>
			</div>`
		);

		options.confirmButton.onClick();
	});

	$('.btn-action', dialog).show();

	dialog.modal('show');

	return dialog;
}

/**
 * Display a dialog presenting 2 choices with the content and callbacks passed in the options
 * @param {object} options Object containing the content to populate the dialog and the events callbacks
 */
function showBinaryChoiceDialog(options) {
	let dialog = $("#atl-duplicate-dialog");
	$('h3', dialog).text(options.title);
	$('.modal-body', dialog).html(`<div class="normal-body">${options.body}</div>`);

	$('.btn-action', dialog).off();
	$('.btn-action', dialog).attr("href", null);

	$('.btn-action', dialog).on('click', function () {

		// hide button and display spinner
		$('.btn-action', dialog).hide();
		$('.normal-body').hide();
		$('.modal-body', dialog).append(
			`<div class='loader-container-center'>
				<div class='spinner-border'></div>
			</div>`
		);
	});

	$('.yes', dialog).on('click', function () {
		options.yesButton.onClick();
	});

	$('.no', dialog).on('click', function () {
		options.noButton.onClick();
	});

	$('.yes', dialog).text(options.yesButton.title);
	$('.no', dialog).text(options.noButton.title);

	if (options.yesButton.width) {
		$('.yes', dialog).width(options.yesButton.width);
	}

	$('.btn-action', dialog).show();

	dialog.modal('show');

	return dialog;
}

function cancelDialogSubmission(dialog) {
	$(dialog).find('.loader-container-center').remove();
	$(dialog).find('.normal-body').show();
	$(dialog).find('.btn-action').show();
}

/**
 * Print all the fields of a form data into the console
 * @param {FormData} formData 
 */
function logFormData(formData) {
	const keys = formData.keys();
	const values = formData.values();

	for (const key of keys) {
		console.log(`${key}: ${values.next().value}`);
	}
}

$(function () {
	//prevents forms submission of form by pressing "enter"
	$(document).on("keydown", "form", function(event) { 
		const currentField = document.activeElement.tagName.toLowerCase();
		if (event.originalEvent.key === "Enter" && currentField !== "textarea") {
			event.preventDefault();
			// focus on next input
			var canfocus = $(':focusable');
			var index = canfocus.index(document.activeElement) + 1;
			if (index >= canfocus.length) index = 0;
			canfocus.eq(index).trigger("focus");
			return false;
		}
	});

	/* MASKS FOR INPUT FIELDS */
	$('.card-nb-mask').mask("9999 9999 9999 9999");
	$('.card-expiry-mask').mask("99/99");
});